<script setup lang="ts">
const error = useError();
const showErrorDetails = computed(() => process.env.NODE_ENV !== 'production');
</script>

<template>
    <NuxtLayout name="content">
        <NuxtLoadingIndicator color="#142542" :height="2" class="shadow-lg" />
        <template #aside>
            <TheSidebar />
        </template>
        <ErrorPage>
            <template #errorMessage>
                <div class="mx-auto">
                    <div class="text-center">
                        <BaseHeading variant="md-700">
                            Ein Fehler ist aufgetreten
                        </BaseHeading>
                        <BaseText class="mt-2">
                            Bitte versuchen Sie es erneut oder wenden Sie sich gerne an
                            <JamBaseLink href="mailto:shop-support@karriere.at"
                            >
                                shop-support@karriere.at
                            </JamBaseLink>
                        </BaseText>
                        <JamBaseLink
                            external
                            :href="`${useRuntimeConfig().public.base.url}`"
                            class="mt-6"
                            stroke-size="thin"
                            variant="green"
                        >
                            Zurück zur Startseite
                        </JamBaseLink>
                    </div>
                    <details v-if="showErrorDetails" class="mt-3" open>
                        <summary>Details</summary>
                        <span
                            v-for="(value, key) in error"
                            :key="key"
                            class="block text-xs"
                        >{{ key }} : {{ value }}{{ '\n' }}</span
                        >
                    </details>
                </div>
            </template>
        </ErrorPage>
    </NuxtLayout>
</template>
